import React from 'react';

import { CalendarEvents } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CalendarEvent } from '@ragu-components/ord-types';

const CalendarEventsList = React.lazy(async () => import('./CalendarEventsList'));

export const calendarEventsResource: OrdResourceProps = {
  key: CalendarEvents,
  name: CalendarEvents,
  list: <CalendarEventsList />,
  options: {},
  recordRepresentation: (record: CalendarEvent): string => record.title,
};
